import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEllipsisV,
  faFileExcel,
  faFilePdf,
} from "@fortawesome/free-solid-svg-icons";
import Table from "react-bootstrap/Table";
import { Link } from "react-router-dom";
import {
  BodyAsFormData,
  encodedUrlBuliding,
} from "../../../services/utilities/util";
import FilterContext from "../../../routes/FilterContext";
import { apiMiddleware } from "../../../services/apis/apiMiddleware";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import jsPDF from "jspdf";
import "jspdf-autotable";
import md5 from "md5";
import { downloadPdf } from "../../../services/utilities/util";
import { connect } from "react-redux";
function mapStateToProps(state) {
  return { filters: state.selectedFilters };
}
class SelectedAsset extends React.Component {
  static contextType = FilterContext;

  state = {
    selectedAssets: [],
    filters: "",
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    var filters;
    if (JSON.stringify(this.props.filters) == "{}") {
      filters = JSON.stringify(this.context.filters);
    } else {
      filters = JSON.stringify(this.props.filters);
    }
    // this.state.filters = filters;
    this.setState({ filters: filters });
    apiMiddleware
      .post(
        "api/edge/office/get_multiple_asset_details",
        BodyAsFormData(filters)
      )
      .then((res) => {
        this.setState({ selectedAssets: res.data.slice(0, 5) });
      });
  }

  componentDidUpdate() {
    if (this.props.filters != this.state.filters) {
      this.setState({ filters: this.props.filters });

      apiMiddleware
        .post(
          "api/edge/office/get_multiple_asset_details",
          BodyAsFormData(JSON.stringify(this.props.filters))
        )
        .then((res) => {
          this.setState({ selectedAssets: res.data.slice(0, 5) });
        });
    }
  }

  render() {
    return (
      <div className="widget widgetTable">
        <div className="row">
          <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
            <p>Assets</p>
          </div>
          <div className="col-lg-3 text-end">
            <p className="colorBlack downloads">
              <FontAwesomeIcon icon={faEllipsisV} />
              <ul className="downloadOptions">
                <li className="excelDownload">
                  <ReactHTMLTableToExcel
                    id="selectedAssetsTableXlsButton"
                    className="download-table-xls-button"
                    table="selectedAssets"
                    filename="RecentTransactions"
                    sheet="RecentTransactions"
                    buttonText={"Download as Excel"}
                  />
                </li>
                <li
                  className="pdfDownload"
                  onClick={(e) => {
                    downloadPdf("#selectedAssets", "RecentTransactions");
                  }}
                >
                  <FontAwesomeIcon icon={faFilePdf} /> Download as PDF
                </li>
              </ul>
            </p>
          </div>
          <div className="col-lg-12 mt-2 newFixedTable">
            <Table responsive hover id="selectedAssets">
              <thead>
                {/* <tr className="">
                  <th>Asset Name</th>
                  <th>Developer</th>
                  <th>Macro-market</th>
                  <th className="text-end">Leasable Area (msf)</th>
                  <th>Completion Date</th>
                </tr> */}
                <tr className="">
                  <th>
                    <span>Asset Name</span>
                  </th>
                  <th>
                    <span>Developer</span>
                  </th>
                  <th>
                    <span>Macro-market</span>
                  </th>
                  <th className="text-end">
                    <span>Leasable Area</span>
                  </th>
                  <th>
                    <span>Completion Date</span>
                  </th>
                </tr>
                <tr className="thwithNoPadding">
                  <th></th>
                  <th></th>
                  <th></th>
                  <th className="text-end">
                    <b>(msf)</b>
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {this.state.selectedAssets.map((row, i) => (
                  <tr className="" key={i}>
                    <td>{row.complex}</td>
                    <td>{row.developer}</td>
                    <td>{row.macromarket}</td>
                    <td className="text-end">{row.leasable_area}</td>
                    <td>{row.occupancy_date_orig}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(SelectedAsset);
